import {
    InterfaceFactoryOptions,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ComponentLogic } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-logic/base/component-logic';
import {
    IBaseComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/base-component.interface';
import {
    PlaceHolderComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/place-holder-component';
import { getPlaceHolderType } from '@editor/src/page/index/components/canvas/element-types/shape-element/utils';
import { PlaceHolderMode } from '@src/slide/domain/ui-model/element-modeles/property/placeholder/PlaceHolderMode';
import {
    updateSavedPlaceHolderParagraphList,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/place-holder-component/utils';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';
import {
    ITextBodyStyle,
} from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';

export class PlaceHolderLogic extends ComponentLogic {
    declare protected component: PlaceHolderComponent;
    declare protected componentOptions: InterfaceFactoryOptions<IShapeModel>;

    public constructor(componentOptions: InterfaceFactoryOptions<IElementBaseModel>, component: IBaseComponent) {
        super(componentOptions, component);
        this.component.setEventHandlers({
            textEditorClickCallback: this.handleEditorClick,
            textEditorChangeCallback: this.handleChange,
        });
    }

    private handleEditorClick = (e) => {
        const { model } = this.componentOptions;
        const type = getPlaceHolderType(model);
        const clearType = [
            PlaceHolderMode.BODY,
            PlaceHolderMode.CTRTITLE,
            PlaceHolderMode.SUBTITLE,
            PlaceHolderMode.TXT,
            PlaceHolderMode.TITLE,
            PlaceHolderMode.SLIDENUM,
            PlaceHolderMode.DATETIME,
            PlaceHolderMode.FOOT,
            PlaceHolderMode.TBL,
            PlaceHolderMode.PIC,
        ];
        if (clearType.indexOf(type) > -1) {
            this.component.clickCallBack?.(PlaceHolderMode.TXT, e);
        }
        e?.stopPropagation();
    };

    private handleChange = (textBodyInfo: {
        paragraphList: IParagraph[], textBodyStyle: ITextBodyStyle
    }) => {
        const { paragraphList, textBodyStyle } = textBodyInfo;
        const { model } = this.componentOptions;
        model?.updateParagraphList(updateSavedPlaceHolderParagraphList(paragraphList), textBodyStyle);
    };
}
